export type ApprovalSettingsType = {
    uid: string
    reportId: string
    reportName: string
    isReportDraft: boolean
    scheduleId: string
    scheduleName: string
    recipientGroupId: string[]
    alertRuleId: string
    alertRuleName: string
    isScheduleActive: boolean
    assets: string[]
    timespan: string
    frequency: string
    hour: string
    isApprovalSettingsDraft?: boolean
    isApprovalSettingsValid: boolean
}

export interface MailSettingsInstance {
    isReportDraft: boolean
    isRuleAlarm: boolean
    alertRule: {
        id: string
        name: string
    }
    recipientGroupId: string[]
    isScheduleActive: boolean
    scheduleId: string
}

export type ScheduleType = {
    type: string
    alertRule: string
}

export interface Alarm extends ScheduleType {
    name: string
    data: any
}

export type SelectOptionsType = {
    value: string
    label: string
}

export interface RequestApi {
    success: boolean
    count: number
}

export interface ResponseType {
    success: boolean
    error: string
}

export interface newApprovalSettings extends RequestApi {
    config: ApprovalSettingsType
}

export interface ApprovalSettingsList {
    success: boolean
    count: number
    configs: ApprovalSettingsType[]
}

export interface ApprovalSettings {
    success: boolean
    count: number
    configs: ApprovalSettingsType
}

export const defaultApprovalSettingsList = {
    success: false,
    count: 0,
    configs: []
} as ApprovalSettingsList

export interface DeletedApprovalSettings extends RequestApi {
    deleted: true
}
